// 游戏列表详情
const gameListInfo = [
  {
    path: '抽奖1',
    name: '抽奖1',
    component: () => import('@/pages/news/game/gamelistinfo/game1')
  },
  {
    path: '抽奖2',
    name: '抽奖2',
    component: () => import('@/pages/news/game/gamelistinfo/game2')
  }
]
// 案例详情列表
const caseListInfo = [
  {
    path: 'oppo',
    name: 'oppo',
    component: () => import('@/pages/news/case/caseinfo/oppo')
  }
]
// 导出路由
export default [
  {
    path: '/',
    name: 'index',
    component: () => import('@/pages/index/index')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/pages/about/index')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/pages/news/index'),
    redirect: '/news/case/list',
    children: [
      {
        path: 'case',
        name: 'case',
        component: () => import('@/pages/news/case/index'),
        redirect: '/case/list',
        children: [
          {
            path: 'list',
            name: 'newsList',
            component: () => import('@/pages/news/case/caselist/index')
          },
          ...caseListInfo
        ]
      },
      {
        path: 'game',
        name: 'game',
        component: () => import('@/pages/news/game/index'),
        redirect: '/news/game/list',
        children: [
          {
            path: 'list',
            name: 'gameList',
            component: () => import('@/pages/news/game/gamelist/index')
          },
          ...gameListInfo
        ]
      }
    ]
  },
  {
    path: '/projects',
    name: 'projects',
    component: () => import('@/pages/projects/index'),
    redirect: '/projects/conference',
    children: [
      {
        path: 'conference',
        name: 'conference',
        component: () => import('@/pages/projects/conference/index')
      },
      {
        path: 'wedding',
        name: 'wedding',
        component: () => import('@/pages/projects/wedding/index'),
        children: [...caseListInfo]
      }
    ]
  },
  {
    path: '*',
    name: 'null',
    // component: () => import('@/pages/index/index')
    component: () => import('@/components/404')
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js